import { Component, HostBinding, Input } from '@angular/core';

import { EventScoreboard, PairScore, SnookerScore } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    template: '',
    standalone: false,
})
export abstract class SnookerScoreboardBaseComponent {
    @Input() scoreboard: EventScoreboard;
    @Input() hasExtended: boolean;
    scoreboardP: string;
    scoreboardF: string;

    constructor(private sitecore: Sitecore) {
        this.scoreboardP = this.sitecore.eventGrid.Scoreboard_P;
        this.scoreboardF = this.sitecore.eventGrid.Scoreboard_F;
    }

    @HostBinding('class.hidden')
    get hidden(): boolean {
        return !this.score || !this.score.frames;
    }

    get score(): SnookerScore | undefined {
        return this.scoreboard.score as SnookerScore;
    }

    get points(): PairScore<number> | undefined {
        if (this.hidden || !this.score || (this.score.participant1 === 0 && this.score.participant2 === 0)) {
            return;
        }

        return {
            participant1: this.score.participant1,
            participant2: this.score.participant2,
        };
    }

    get frames(): PairScore<number> | undefined {
        if (this.hidden || !this.score) {
            return;
        }

        return {
            participant1: this.score.frames.participant1,
            participant2: this.score.frames.participant2,
        };
    }
}
